/**
 * @fileoverview Browser history instance for React Router navigation.
 */

import {
  createBrowserHistory as createHistoryV5,
  type BrowserHistory,
  type Transition,
} from "history";
import {createPath, parsePath, type To} from "@remix-run/router";

type AppHistory = BrowserHistory & {
  createURL(to: To): URL;
  encodeLocation(to: To): {pathname: string; search: string; hash: string};
};

function encodeLocation(to: To) {
  const path = typeof to === "string" ? parsePath(to) : to;
  return {
    pathname: path.pathname ?? "",
    search: path.search ?? "",
    hash: path.hash ?? "",
  };
}

function createURL(to: To): URL {
  const href = typeof to === "string" ? to : createPath(to);
  const base =
    window.location.origin !== "null"
      ? window.location.origin
      : window.location.href;
  return new URL(href, base);
}

const baseHistory = createHistoryV5();

/**
 * Browser history instance used throughout the application for navigation.
 * Uses history v5 for `block()` (navigation prompts); adds Remix Router helpers
 * required by `unstable_HistoryRouter`.
 */
export const history: AppHistory = Object.assign(baseHistory, {
  createURL,
  encodeLocation,
});

export type {Transition};
